/**
 * Menu panel (snippets/header-menu-panel.liquid)
 * <header-menu-panel>
 *  - Mobile accordion: each group button opens / closes its pills (several can be open).
 *  - "Close" link: closes the panel through the menu button, so the theme's <header-drawer>
 *    (assets/global.js) runs its normal close: animation, scroll unlock and focus return.
 * Opening, Escape, outside click and the focus trap are handled by <header-drawer>.
 */
(() => {
  if (customElements.get('header-menu-panel')) return;

  class HeaderMenuPanel extends HTMLElement {
    #controller = new AbortController();

    connectedCallback() {
      const { signal } = this.#controller;
      this.addEventListener('click', (event) => {
        const target = /** @type {HTMLElement} */ (event.target);

        const toggle = target.closest('[data-menu-panel-toggle]');
        if (toggle) {
          this.#toggleGroup(toggle);
          return;
        }

        if (target.closest('[data-menu-panel-close]')) {
          this.closest('details')?.querySelector('summary')?.click();
        }
      }, { signal });
    }

    disconnectedCallback() {
      this.#controller.abort();
      this.#controller = new AbortController();
    }

    /** @param {Element} toggle */
    #toggleGroup(toggle) {
      const group = toggle.closest('[data-menu-panel-group]');
      if (!group) return;
      const open = !group.hasAttribute('data-open');
      group.toggleAttribute('data-open', open);
      toggle.setAttribute('aria-expanded', String(open));
    }
  }

  customElements.define('header-menu-panel', HeaderMenuPanel);
})();
